//  theme
export const SUCCESS_PRESENTATION_DETAIL = "SUCCESS_PRESENTATION_DETAIL";
export const LOADING_PRESENTATION_DETAIL = "LOADING_PRESENTATION_DETAIL";
export const SUCCESS_PRESENTATION_BUILD = "SUCCESS_PRESENTATION_BUILD";
export const LOADING_PRESENTATION_BUILD = "LOADING_PRESENTATION_BUILD";
